import React from "react";
import ChlastLogoSvg from "./ChlastLogo.svg?react";

interface ChlastLogoProps {
  size?: number;
}

const DEFAULT_SIZE = 24;

const ChlastLogo: React.FC<ChlastLogoProps> = ({ size = DEFAULT_SIZE }) => (
  <ChlastLogoSvg width={size} height={size} aria-hidden="true" />
);

export default ChlastLogo;
